package com.essntl.features.task.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.features.task.ui.alltasks.components.TaskStatusDropDown
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.dropdown.EsDropdownMenuItem
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import core.dateformat.ui.formatDate

@Composable
fun TaskBox(
    task: TaskModel,
    onEditTask: () -> Unit,
    onDeleteTask: () -> Unit,
    onEditTaskStatus: (status: TaskModel.Status) -> Unit,
    modifier: Modifier = Modifier,
) {
    var isDropDownExpanded by remember { mutableStateOf(false) }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = modifier
            .clip(RoundedCornerShape(16.dp))
            .background(color = MaterialTheme.esColorScheme.bgPrimary)
            .padding(1.5f.spacing)
            .heightIn(min = 30.dp),
    ) {
        Text(
            text = task.title ?: "",
            style = MaterialTheme.esTypography.p1Medium16,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier.weight(3f),
        )

        Text(
            text = task.dueDate?.formatDate(".", excludeYear = true) ?: "_",
            style = MaterialTheme.esTypography.p2Medium14,
            modifier = Modifier.weight(2f),
        )

        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center,
        ) {
            TaskStatusDropDown(
                status = task.status ?: TaskModel.Status.Todo,
                onStatusSelected = { newStatus ->
                    if (newStatus != task.status)
                        onEditTaskStatus(newStatus)
                },
            )

            Spacer(modifier = Modifier.width(1.spacing))

            Box(contentAlignment = Alignment.Center) {
                EsLargeIcon(
                    res = EsIcons.MoreVertical,
                    tint = LocalContentColor.current,
                    modifier = Modifier
                        .clip(CircleShape)
                        .pointerHoverIcon(PointerIcon.Hand)
                        .clickable {
                            isDropDownExpanded = true
                        },
                )

                EsDropDownMenu(
                    expanded = isDropDownExpanded,
                    onDismissRequest = { isDropDownExpanded = false },
                    modifier = Modifier
                        .width(187.dp),
                ) {
                    EsDropdownMenuItem(
                        text = "Edit",
                        prefixIcon = EsIcons.Edit,
                        iconColor = MaterialTheme.esColorScheme.iconPrimary,
                        onClick = {
                            isDropDownExpanded = false
                            onEditTask()
                        },
                        modifier = Modifier.height(40.dp),
                    )

                    EsDropdownMenuItem(
                        text = "Delete",
                        prefixIcon = EsIcons.Trash,
                        iconColor = MaterialTheme.esColorScheme.iconPrimary,
                        onClick = {
                            isDropDownExpanded = false
                            onDeleteTask()
                        },
                        modifier = Modifier.height(40.dp),
                    )
                }
            }
        }
    }
}